import Modal from "@/components/Modal"
import SkeletonTable from "@/components/SkeletonTable"
import { Button } from "@/components/ui/button"
import api from "@/lib/axios"
import { useState } from "react"
import { LuListFilter } from "react-icons/lu"
import { useQuery } from "@tanstack/react-query"
import FormFilter from "./FormFilter"
import { useSearchParams } from "react-router-dom"
import useApiBaseUrl from "@/hooks/useApiBaseUrl"
import { RiFileExcel2Fill } from "react-icons/ri"

const getDataRekapPendaftaran = async (
  ids_ref_jalur_jenis?: string,
  ids_uk?: string
) => {
  const params = new URLSearchParams(location.search)

  if (ids_ref_jalur_jenis)
    params.append("ids_ref_jalur_jenis", ids_ref_jalur_jenis)

  if (ids_uk) params.append("ids_uk", ids_uk)

  const response = await api.get(
    `/dashboard/rekap-pendaftaran?${params.toString()}`
  )
  return response.data?.data
}

type DataRekapPendaftaran = {
  jalur_jenis: string
  fakultas_nama: string
  jurusan_nama: string
  prodi_nama: string
  jumlah_pendaftar: number
  jumlah_validasi: string
  jumlah_lulus: number
  jumlah_daftar_kembali: number
  jumlah_isi_ukt: number
  jumlah_valid_isi_ukt: number
  jumlah_bayar_ukt: number
}

export default function TabelRekap() {
  const [searchParams] = useSearchParams()
  const idsUkParams = searchParams.get("ids_uk") || ""
  const idsJalurJenisParams = searchParams.get("ids_ref_jalur_jenis") || ""

  const { apiBaseUrl } = useApiBaseUrl()
  const [showFilter, setShowFilter] = useState(false)

  const {
    data: dataRekapPendaftaran = [],
    isPending: isPendingDataRekapPendaftaran,
  } = useQuery({
    queryKey: ["dataRekapPendaftaran", idsJalurJenisParams, idsUkParams],
    queryFn: () => getDataRekapPendaftaran(idsJalurJenisParams, idsUkParams),
  })

  if (isPendingDataRekapPendaftaran) return <SkeletonTable />

  return (
    <div>
      <div className="mb-3 flex gap-3 items-center">
        <h1 className="text-xl font-bold">Tabel Rekap Daftarkembali</h1>
        <Button
          variant={"outline"}
          className="flex items-center gap-x-3"
          onClick={() => setShowFilter((show) => !show)}
        >
          Filter <LuListFilter />
        </Button>
        <Button
          variant={"outline"}
          className="flex items-center gap-x-3"
          onClick={() => {
            if (idsJalurJenisParams)
              searchParams.set("ids_ref_jalur_jenis", idsJalurJenisParams)
            if (idsUkParams) searchParams.set("ids_uk", idsUkParams)

            window.open(
              `${apiBaseUrl}/dashboard/rekap-pendaftaran/export?${searchParams?.toString()}`
            )
          }}
        >
          Export <RiFileExcel2Fill />
        </Button>
      </div>
      <div className="flex-1 overflow-auto rounded-xl border">
        <table className="table-auto w-full border-collapse border rounded-xl overflow-hidden">
          <thead>
            <tr>
              <th className="py-1 px-2 border font-semibold text-start">
                Jalur
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Fakultas
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Jurusan
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Program Studi
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Peminat
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Validasi
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Lulus
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Isi UKT
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Valid Isi UKT
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Bayar UKT
              </th>
              <th className="py-1 px-2 border font-semibold text-start">
                Sudah Daftarkembali
              </th>
            </tr>
          </thead>
          <tbody>
            {dataRekapPendaftaran?.rekap?.length > 0
              ? dataRekapPendaftaran?.rekap?.map(
                  (item: DataRekapPendaftaran, index: number) => {
                    return (
                      <tr key={index}>
                        <td className="py-1 px-2 border">{item.jalur_jenis}</td>
                        <td className="py-1 px-2 border">
                          {item.fakultas_nama}
                        </td>
                        <td className="py-1 px-2 border">
                          {item.jurusan_nama}
                        </td>
                        <td className="py-1 px-2 border">{item.prodi_nama}</td>
                        <td className="py-1 px-2 border text-center">
                          {item.jumlah_pendaftar}
                        </td>
                        <td className="py-1 px-2 border text-center">
                          {item.jumlah_validasi}
                        </td>
                        <td className="py-1 px-2 border text-center">
                          {item.jumlah_lulus}
                        </td>
                        <td className="py-1 px-2 border text-center">
                          {item.jumlah_isi_ukt}
                        </td>
                        <td className="py-1 px-2 border text-center">
                          {item.jumlah_valid_isi_ukt}
                        </td>
                        <td className="py-1 px-2 border text-center">
                          {item.jumlah_bayar_ukt}
                        </td>
                        <td className="py-1 px-2 border text-center">
                          {item.jumlah_daftar_kembali}
                        </td>
                      </tr>
                    )
                  }
                )
              : ""}
          </tbody>
          <tfoot>
            <tr>
              <td
                className="py-1 px-2 border font-semibold text-center"
                colSpan={4}
              >
                Total
              </td>
              <td className="py-1 px-2 border text-center">
                {dataRekapPendaftaran?.total?.total_pendaftar}
              </td>
              <td className="py-1 px-2 border text-center">
                {dataRekapPendaftaran?.total?.total_validasi}
              </td>
              <td className="py-1 px-2 border text-center">
                {dataRekapPendaftaran?.total?.total_lulus}
              </td>
              <td className="py-1 px-2 border text-center">
                {dataRekapPendaftaran?.total?.total_isi_ukt}
              </td>
              <td className="py-1 px-2 border text-center">
                {dataRekapPendaftaran?.total?.total_valid_isi_ukt}
              </td>
              <td className="py-1 px-2 border text-center">
                {dataRekapPendaftaran?.total?.total_bayar_ukt}
              </td>
              <td className="py-1 px-2 border text-center">
                {dataRekapPendaftaran?.total?.total_daftar_kembali}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <Modal show={showFilter} onClose={() => setShowFilter(false)} width="2xl">
        <FormFilter closeModal={() => setShowFilter(false)} />
      </Modal>
    </div>
  )
}
